import 'swiper/swiper-bundle.css';

import { Button, Icon, Image, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { HomeTopCategoriesSkeletons } from '@hero/components/skeletons';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';

import { filterDashboardOccasions } from '../ThankYouAndOccasions/utils';

import * as S from './style';

export function HomeUpcomingOccasions() {
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const swiper = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = {
    spaceBetween: 12,
    slidesPerView: 'auto',
    slidesPerGroup: 6,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 4
    }
  };

  const { data: occasionsData, isLoading } = useGetCSEntries({
    entryCode: 'sgb_admin_dashboard_occasions',
    params: {
      query: {
        'global_field.merchant_code': ''
      }
    }
  });
  const occasions = filterDashboardOccasions(occasionsData?.entries?.[0]?.occasions);

  if (occasions && occasions.length === 0) return null;

  return (
    <S.HomeUpcomingOccasionsWrapper>
      <S.HeaderWrapper>
        <Typography variant="subtitle1Bold">{t('upcomingOccasions')}</Typography>
        <VerticalDivider
          $margin="0 16px"
          $height="24px"
          color="var(--color-components-input-border-strong)"
        />
        <Button
          size="lg"
          variant="link"
          color="bg"
          onClick={() => navigate(ROUTE_PATHS.GIFT_CATALOG)}
        >
          {t('seeAll')}
        </Button>
      </S.HeaderWrapper>
      <S.HomeUpcomingOccasions>
        <S.NavigationButton color="secondary" variant="link" ref={navigationPrevRef}>
          <Icon name="left-chevron" size="lg" />
        </S.NavigationButton>

        {isLoading ? (
          <S.CategorySkeleton>
            <HomeTopCategoriesSkeletons />
          </S.CategorySkeleton>
        ) : (
          <Swiper
            ref={swiper}
            {...params}
            pagination={{
              clickable: true
            }}
          >
            {occasions?.map(occasion => (
              <SwiperSlide
                style={{
                  width: 240,
                  height: 300,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                key={occasion.collection_id}
              >
                <S.OccasionItem
                  as="div"
                  onClick={() => {
                    const search = qs.stringify({
                      categoryIds: [occasion.collection_id]
                    });
                    navigate(`${ROUTE_PATHS.GIFT_CATALOG}?${search}`);
                  }}
                >
                  <Typography variant="body2SemiBold">{occasion.name}</Typography>
                  <Image src={occasion?.cover_image_url} width="100%" />
                </S.OccasionItem>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <S.NavigationButton color="secondary" variant="link" ref={navigationNextRef}>
          <Icon name="right-chevron" size="lg" />
        </S.NavigationButton>
      </S.HomeUpcomingOccasions>
    </S.HomeUpcomingOccasionsWrapper>
  );
}
